var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "30px",
    height: "30px",
    viewBox: "0 0 1.2 1.2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leaf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.108 0.107a0.028 0.028 0 0 0 -0.021 -0.02l0 0a0.028 0.028 0 0 0 -0.028 0.01l0 0a0.525 0.525 0 0 1 -0.242 0.162l-0.004 0.001c-0.063 0.021 -0.137 0.035 -0.214 0.041l-0.003 0c-0.084 0.003 -0.162 0.022 -0.234 0.053l0.004 -0.002c-0.124 0.067 -0.206 0.196 -0.206 0.344l0 0.007v0q0 0.017 0.002 0.034c0.006 0.045 0.018 0.086 0.036 0.123l-0.001 -0.002a1.11 1.11 0 0 0 -0.146 0.25l-0.003 0.007a0.028 0.028 0 0 0 0.052 0.022l0 0c0.036 -0.087 0.078 -0.161 0.128 -0.23l-0.002 0.003a0.416 0.416 0 0 0 0.171 0.151l0.003 0.001a0.439 0.439 0 0 0 0.181 0.039h0.003a0.521 0.521 0 0 0 0.2 -0.041l-0.003 0.001c0.197 -0.089 0.338 -0.274 0.363 -0.493l0 -0.003a1.125 1.125 0 0 0 0.009 -0.141c0 -0.113 -0.016 -0.223 -0.047 -0.326l0.002 0.008zm-0.02 0.45a0.564 0.564 0 0 1 -0.325 0.451l-0.004 0.001a0.42 0.42 0 0 1 -0.17 0.035c-0.06 0 -0.117 -0.012 -0.169 -0.035l0.003 0.001a0.361 0.361 0 0 1 -0.159 -0.145l-0.001 -0.002c0.124 -0.143 0.286 -0.214 0.518 -0.237a0.028 0.028 0 0 0 -0.006 -0.056h0a0.79 0.79 0 0 0 -0.538 0.238l0 0a0.33 0.33 0 0 1 -0.02 -0.078l0 -0.002a0.337 0.337 0 0 1 -0.002 -0.035 0.332 0.332 0 0 1 0.173 -0.292l0.002 -0.001c0.062 -0.027 0.134 -0.043 0.209 -0.046l0.001 0a1.02 1.02 0 0 0 0.237 -0.046l-0.007 0.002a0.611 0.611 0 0 0 0.235 -0.14l0 0c0.02 0.076 0.031 0.163 0.031 0.252q0 0.07 -0.009 0.138l0.001 -0.005z",
    stroke: "#F8AEA1",
    fill: "#F8AEA1",
    strokeWidth: 0.0375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.f33427deb1a66085257c46aec8a28607.svg";
export { ForwardRef as ReactComponent };